import { render, staticRenderFns } from "./ChipsWithMoreResource.vue?vue&type=template&id=525f0afc"
import script from "./ChipsWithMoreResource.vue?vue&type=script&lang=ts"
export * from "./ChipsWithMoreResource.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('525f0afc')) {
      api.createRecord('525f0afc', component.options)
    } else {
      api.reload('525f0afc', component.options)
    }
    module.hot.accept("./ChipsWithMoreResource.vue?vue&type=template&id=525f0afc", function () {
      api.rerender('525f0afc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ChipsWithMoreResource.vue"
export default component.exports